module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAMAAACecocUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFAAAA/f39emVIHQAAAAJ0Uk5T/wDltzBKAAAAMElEQVR42lTLAQoAAARD0b/7X5oYQenRoCogxzAXDnGgu7MFc6I6fncv/reXCgEGABPTAFKFjG5BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/phone.png
// module id = 9
// module chunks = 0 1